import OldSiteRedirectAlert from './OldSiteRedirectAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NoQueryEntered() {
  return /*#__PURE__*/_jsxs("div", {
    className: "p-top-10 p-bottom-14",
    "data-test-id": "no-query-entered",
    children: [/*#__PURE__*/_jsx("div", {
      className: "p-bottom-14",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.search.noQuery"
      })
    }), /*#__PURE__*/_jsx(OldSiteRedirectAlert, {})]
  });
}
export default NoQueryEntered;